/**
 * Interface Segregation Principle - Define minimal generator interface
 */
export class IGenerator {
  generate(options = {}) {
    throw new Error('generate method must be implemented');
  }
}